import React from 'react';
import { CustomHeader } from 'react-calendar-timeline';
import { AutomedicTimelineView } from '../../types';

interface TimelineDayHeaderProps {
  features: {
    automedicView: boolean;
  };
  viewPoint: AutomedicTimelineView;
  showDays: boolean;
}

const TimelineDayHeader: React.FC<TimelineDayHeaderProps> = ({
  features,
  viewPoint,
  showDays,
}) => {
  return (
    // @ts-ignore
    <CustomHeader unit="day">
      {(props: any) => {
        const {
          headerContext: { intervals },
          getRootProps,
          getIntervalProps,
        } = props;
        return (
          <div {...getRootProps()} className="dayHeader">
            {intervals.map((interval: any) => {
              const intervalStyle: React.CSSProperties = {
                lineHeight: '20px',
                fontFamily: '"Roboto Condensed",Helvetica,Arial,"sans-serif"',
                fontSize: '11px',
                fontWeight: 'bold',
              };
              if (
                features.automedicView &&
                (viewPoint === AutomedicTimelineView.WEEK_VIEW ||
                  viewPoint === AutomedicTimelineView.MULTI_DAY_VIEW)
              ) {
                return (
                  <div
                    key={interval.startTime.valueOf()}
                    {...getIntervalProps({
                      interval,
                      style: intervalStyle,
                    })}
                  >
                    {showDays && interval.startTime.format('ddd (D/M)')}
                  </div>
                );
              }

              return (
                <div
                  className=" roboto"
                  key={interval.startTime.valueOf()}
                  {...getIntervalProps({
                    interval,
                    style: intervalStyle,
                  })}
                >
                  {showDays && interval.startTime.format('DD')}
                </div>
              );
            })}
          </div>
        );
      }}
    </CustomHeader>
  );
};

export default TimelineDayHeader;
